import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { Tab } from '@headlessui/react';
import Modal from '../../components/Modal/Modal';
import FormTextInput from '../../components/Form/FormTextInput';

const EditDrawingDescriptionModal = ({
                             open, onClose, editFunction, editIndex, defaultValue
                         }) => {
    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const [formikInitialValues, setFormikInitialValues] = useState({
        drawingName: defaultValue
    });

    const validationSchema = Yup.object().shape({
        drawingName: Yup.string(),
    });

    useEffect(() => {
        setFormikInitialValues({
            drawingName: defaultValue,
        });
    }, [defaultValue]);

    const onSubmitHandler = async (formData) => {
        try {
            editFunction(editIndex, formData.drawingName);
            onCloseButtonClickHandler();
            toast.success('Success');
        } catch {
            toast.error('Something went wrong. Please try again');
        }
    };

    return (
        <Modal open={open} setOpen={onCloseButtonClickHandler}>
            <div className="px-2">
                <Tab.Group>
                    <Tab.Panels>
                        <Formik
                            enableReinitialize
                            initialValues={formikInitialValues}
                            validationSchema={validationSchema}
                            onSubmit={onSubmitHandler}
                        >
                            {({ errors }) => (
                                <Form className="flex flex-col gap-2 py-4">
                                    <FormTextInput name="drawingName" label='Drawing Name' />
                                    <button
                                        // isBlock
                                        // disabled={Object.keys(errors).length > 0 || isLoading}
                                        type="submit"
                                        // isLoading={isLoading}
                                    >
                                        Continue
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </Tab.Panels>
                </Tab.Group>
            </div>
        </Modal>
    );
};

EditDrawingDescriptionModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    editFunction: PropTypes.func.isRequired,
    defaultValue: PropTypes.string.isRequired,
    editIndex: PropTypes.number.isRequired,
};

export default EditDrawingDescriptionModal;
